import React from 'react';
import styles from './FormLayout.module.css';

const AlertIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" aria-hidden="true" {...props}>
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 8v5M12 16h.01"/>
    </svg>
);

// The white card chrome a settings-style form sits in: title, description,
// an optional error summary, then whatever FormSections/FormFooter you pass.
export const FormCard = ({titleId, title, description, onSubmit, children}) => (
    <form aria-labelledby={titleId} onSubmit={onSubmit} className={styles.card}>
        <div className={styles.header}>
            <h3 id={titleId} className={styles.title}>{title}</h3>
            {description && <p className={styles.description}>{description}</p>}
        </div>
        {children}
    </form>
);

// "{n} field(s) need attention", with a link to each broken field. Render
// this right after FormCard's header when a submit has failed validation.
export const FormErrorSummary = ({errors}) => {
    if (!errors || errors.length === 0) return null;
    return (
        <div role="alert" className={styles.errorSummary}>
            <AlertIcon className={styles.errorSummaryIcon}/>
            <span>
                {errors.length} field{errors.length === 1 ? '' : 's'} need attention:{' '}
                {errors.map(({fieldId, label}, i) => (
                    <React.Fragment key={fieldId}>
                        {i > 0 && ', '}
                        <a href={`#${fieldId}`} className={styles.errorSummaryLink}>{label}</a>
                    </React.Fragment>
                ))}
            </span>
        </div>
    );
};

// A <fieldset> with an uppercase legend, divided from the previous section
// by a 1px rule (the first section has none, via :first-child in CSS).
export const FormSection = ({legend, columns, children}) => (
    <fieldset className={styles.section}>
        <legend className={styles.legend}>{legend}</legend>
        <div className={columns ? styles.columns : styles.stack}>
            {children}
        </div>
    </fieldset>
);

// The sticky Cancel / Save changes bar. On mobile, Save goes full width with
// Cancel as a text button underneath (handled purely in CSS).
export const FormFooter = ({onCancel, saveLabel = 'Save changes', saving}) => (
    <div className={styles.footer}>
        <button type="button" className={styles.cancelButton} onClick={onCancel}>Cancel</button>
        <button type="submit" className={styles.saveButton} disabled={saving}>
            {saving ? 'Saving…' : saveLabel}
        </button>
    </div>
);
